import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {DjPsycho} from "../../DjPsycho";
import {TimelineLite} from "gsap";
import {DjPsychoSound} from "../../sound/DjPsychoSound";

export class DjPsychoAdditionalFS extends PIXI.Container implements StageLayer {

    private _item: PIXI.spine.Spine;

    constructor() {
        super();
        this.name = "DjPsychoAdditionalFS";

        this.init();
    }

    public awardExtraFS(value: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            animName: string = "Plus_2_" + value;

        tl.add([
            () => {
                // #168
                DjPsycho.soundPlayer.playSound(DjPsychoSound.FS_PLUS_SPINS);

                this._item.visible = true;
            },
            DjPsycho.createTimelineForAnimation(this._item, 0, animName, false)
        ], 0);
        tl.add(() => {
            DjPsycho.model.fsLeftCount += 2;
            DjPsycho.keypadPlugin.setZeroBetSpinCounter(DjPsycho.model.fsLeftCount);
        }, 15 / 30);
        tl.add(() => {
            this._item.visible = false;
        });

        return tl;
    }

    private init(): void {
        this._item = new PIXI.spine.Spine(DjPsycho.assetLoader.getSpineAsset("extraFS"));
        this._item.visible = false;
        this._item.position.set(360);
        this.addChild(this._item);
    }
}